import { render } from "./DailyDigestQuotes.vue?vue&type=template&id=7b50821f&scoped=true"
import script from "./DailyDigestQuotes.vue?vue&type=script&lang=js"
export * from "./DailyDigestQuotes.vue?vue&type=script&lang=js"

import "./DailyDigestQuotes.vue?vue&type=style&index=0&id=7b50821f&scoped=true&lang=css"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b50821f"]])

export default __exports__